"use client";

import { useEffect, useState } from "react";
import CatalogFeature from "@/features/Catalog";
import CartBase from "@/features/Cart/components/Base";

export default function CatalogPage() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");

    const handleResize = () => {
      setIsDesktop(mediaQuery.matches);
    };

    handleResize(); // initial check
    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  return (
    <main className="mx-auto w-full md:max-w-[90vw] pb-25">
      <div
        className={`grid ${isDesktop ? "grid-cols-12 gap-6" : "grid-cols-1"}`}
      >
        {/* Catalog */}
        <div className={isDesktop ? "col-span-8" : ""}>
          <CatalogFeature />
        </div>

        {/* Cart hanya render di desktop */}
        {isDesktop && (
          <div className=" col-span-4 fixed h-[90vh] top-0 right-6 overflow-y-auto">
            <CartBase />
          </div>
        )}
      </div>
    </main>
  );
}
